import { render } from "./CRMDateNavigator.vue?vue&type=template&id=2a37b599"
import script from "./CRMDateNavigator.vue?vue&type=script&lang=js"
export * from "./CRMDateNavigator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__